import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-vDSP/SafeDrivingMonthlyGraph/.eu';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingMonthlyGraph/.kr';

export interface SafeDrivingMonthlyGraphProps {
  dashedLineScore: number;
  coloredItemScoreThreshold?: number;
  items: Omit<ItemProps, 'isActive' | 'onClick'>[];
}

export interface ItemProps {
  score: number | null;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}

export default function SafeDrivingMonthlyGraph(props: SafeDrivingMonthlyGraphProps) {
  return (
    <>
      <Environment.Kr>
        <Kr {...props} />
      </Environment.Kr>
      <Environment.Eu>
        <Eu {...props} />
      </Environment.Eu>
    </>
  );
}
